import { B2bComponent } from '../b2b.component';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { ManagementServiceService } from 'src/app/management-service.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { MatRadioChange } from '@angular/material/radio';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {MatSliderModule} from '@angular/material/slider';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import { B2BService } from 'src/app/b2-b.service';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
   dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-my-offer-requests',
  templateUrl: './my-offer-requests.component.html',
  styleUrls: ['./my-offer-requests.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class MyOfferRequestsComponent implements OnInit {

  constructor(public parent: B2bComponent, private managementService:ManagementServiceService, private B2BService:B2BService, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _bottomSheet: MatBottomSheet,  private route: ActivatedRoute) { 
    translate.addLangs(['en', 'ro', 'de', 'es', 'fr', 'it', 'pl', 'pt']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro|de|es|fr|it|pl|pt/) ? browserLang : 'en');

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };

      // Debounce search.
      this.searchUserUploaderUpdate.pipe(
        debounceTime(400),
        distinctUntilChanged())
        .subscribe(value => {
          this.GetUserUploadersFiltered(value);
        });

          // Debounce search.
     this.searchUserManagerUpdate.pipe(
      debounceTime(400),
      distinctUntilChanged())
      .subscribe(value => {
        this.GetUserManagersFiltered(value);
      });

     // Debounce search.
     this.searchPartnerUpdate.pipe(
      debounceTime(400),
      distinctUntilChanged())
      .subscribe(value => {
        this.GetPartnersFiltered(value, null, true);
      });
  
     // Debounce search.
     this.searchTermUpdate.pipe(
      debounceTime(500),
      distinctUntilChanged())
      .subscribe(value => {
        this.Filter.SearchTerm = value;

        if(this.Filter.SearchTerm?.length > 2){
          this.GetOrdersFiltered(this.Filter.Pager.PageIndex = 1);
        }
      });

     // Debounce main search.
     this.searchMainOrders.pipe(
      debounceTime(500),
      distinctUntilChanged())
      .subscribe(value => {
        this.LoadingMainSearchTerm = true;
        this.Filter.SearchTerm = value;

        if(this.Filter.SearchTerm?.length > 2 || this.Filter.SearchTerm?.length == 0){
          this.GetOrdersFiltered(1);
        }

        this.LoadingMainSearchTerm = false;
      });
  }

  @ViewChild('autosize') autosize: CdkTextareaAutosize;
  searchTermUpdate = new Subject<string>();
  searchPartnerUpdate = new Subject<string>();
  searchUserManagerUpdate = new Subject<string>();
  searchUserUploaderUpdate = new Subject<string>();

  ngOnInit(): void {
    this.InitializeFilter();
    this.parent.InitializeCart();
    this.GetOfferMasterData();
  }

  Filter: {[k: string]: any} = {};
  MasterData: {[k: string]: any} = {};
  CurrentShippingAddress:any;
  activeFilters:{[k: string]: any} = [];
  Orders:{[k: string]: any} = [];
  Totals:{[k: string]: any} = [];
  searchTerm:string;
  Partners:any[];
  resultsLength:number = 0;
  partner:any;
  CurrentOrder:any;

  FromDate = new FormControl(moment());
  ToDate = new FormControl(moment());

  loadingOrders:boolean;
  showFilter:boolean;
  ShowExportBulkQuestion:boolean;
  AllSelected:boolean;
  ShowOrderCancelation:boolean;
  ShowOrderCopy:boolean;
  ShowEditContainer:boolean;

  SearchUserManager:string;
  UserManagers:any[];
  UserManagersLength:number = 0;
  UserManager:any;

  SearchUserUploader:string;
  UserUploaders:any[];
  UserUploadersLength:number = 0;
  UserUploader:any;

  ShowOrderBillingInformation:boolean = true;
  ShowOrderShippingInformation:boolean = true;
  ShowOrderGeneralInformation:boolean = true;
  ShowOrderProductsInformation:boolean = true;

  LoadingMainSearchTerm:boolean = false;
  searchMainOrders = new Subject<string>();

InitializeFilter(){

  this.Filter = {};
  this.Filter.SearchTerm = "";
  this.Filter.DebatorPO = "";

  this.Filter.FromDate = null;
  this.Filter.ToDate = null;

  this.Filter.Pager = {};
  this.Filter.Pager.PageIndex = 1;
  this.Filter.Pager.PageSize = 50;
  this.Filter.Pager.TotalCount = 0;

  this.Filter.Partner = {};
  this.Filter.Partner = null;
  
  this.Filter.UserUploader = {};
  this.Filter.UserUploader = null;
  
  this.Filter.UserManager = {};
  this.Filter.UserManager = null;

  this.Filter.Period = {};
  this.Filter.Period = null;

  this.Filter.Country = {};
  this.Filter.Country = null;

  this.Filter.Currency = {};
  this.Filter.Currency = null;

  this.Filter.Company = {};
  this.Filter.Company = null;

  this.Filter.IndividualStatus = {};
  this.Filter.IndividualStatus = null;

  this.Filter.Status = {};
  this.Filter.Status = null;

  this.Filter.TranzactionType = {};
  this.Filter.TranzactionType = null;

  this.Filter.SortingOrder = {};
  this.Filter.SortingOrder = null;
}

ClearPeriod(){
  this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
  this.Filter.Period = null;
}

DisablePeriod(){
  this.Filter.Period = null;
  this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
}

GetOfferMasterData(){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
  };

  this.parent.loading = true;

  this.B2BService.GetB2BOfferMasterData(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.MasterData = response;
      this.GetOrdersFiltered(1);
    }

    this.parent.loading = false;
   });
}

GetOrdersFiltered(page = 1){

  this.Filter.Pager.PageIndex = page;
  this.Filter.Partner = this.parent.B2BPartner;

  if(this.Filter.DisplayAllPagesTotals == true){
    this.Filter.ExchangeToTargetCurrency = false;
  }

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Filter:this.Filter
  };

  if(request.Filter.FromDate != null){
    request.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
    this.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
  }

  if(request.Filter.ToDate != null){
    request.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
    this.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
  }
  
  this.loadingOrders = true;
  this.showFilter = false;

  this.B2BService.GetB2BOffersFiltered(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Orders = response["Offers"];
      this.Totals = response["Totals"];
      // Pager with TotalCount is now returned from the main query
      this.Filter.Pager = response["Pager"];

      this.FromDate = new FormControl(moment(this.Filter.FromDate));
      this.ToDate = new FormControl(moment(this.Filter.ToDate));
    }

    this.loadingOrders = false;
  });

  // No need for separate COUNT call - it's included in the main response now
}

GetOrdersFilteredCOUNT(){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Filter:this.Filter
  };

  if(request.Filter.FromDate != null){
    request.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
    this.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
  }

  if(request.Filter.ToDate != null){
    request.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
    this.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
  }

  this.B2BService.GetB2BOffersFilteredCOUNT(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Filter.Pager = response["Pager"];

      this.FromDate = new FormControl(moment(this.Filter.FromDate));
      this.ToDate = new FormControl(moment(this.Filter.ToDate));
    }
 
  });
}

AddActiveFilter(filterName:string, filterType:string){
  var filter = {
    ID:this.parent.newGuid(),
    Name:filterName,
    Type:filterType
  };
  
  if(this.Filter.Administration != null && this.activeFilters.find(x => x.Type == filterType)){
    this.showFilter = false;
    this.GetOrdersFiltered();
  }

  this.activeFilters = this.activeFilters.filter(x => x.Name != filterName && x.Type != filterType);
  this.activeFilters.push(filter);

  if(filterType == "Period"){
    this.Filter.FromDate = null;
    this.Filter.ToDate = null;

    this.FromDate = new FormControl(moment(this.Filter.FromDate));
    this.ToDate = new FormControl(moment(this.Filter.ToDate));
  }
}

RemoveActiveFilter(ID:string, filterType:string){
  this.activeFilters = this.activeFilters.filter(x => x.ID != ID);

  if(filterType == "Administration"){
    this.Filter.Administration = null;
  }
  else if(filterType == "Series"){
    this.Filter.AccountingSeries = null;
  }
  else if(filterType == "DocStatus"){
    this.Filter.DocumentStatus = null;
  }
  else if(filterType == "DocumentNumber"){
    this.Filter.DocumentNumber = null;
  }
  else if(filterType == "Product"){
    this.Filter.Product = null;
    this.Filter.SearchTerm = null;
  }
  else if(filterType == "Partner"){
    this.Filter.Partner = null;
  }
  else if(filterType == "Period"){
    this.Filter.Period = null;
  }
  else if(filterType == "Country"){
    this.Filter.Country = null;
  }
  else if(filterType == "Currency"){
    this.Filter.Currency = null;
  }
  else if(filterType == "InvoiceDocType"){
    this.Filter.InvoiceDocType = null;
  }
  else if(filterType == "DebatorPO"){
    this.Filter.DebatorPO = null;
  }
  else if(filterType == "Status"){
    this.Filter.IndividualStatus = null;
  }

  this.GetOrdersFiltered();
}

AnyChecked:boolean;

CheckIfAnyChecked(){
  this.AnyChecked = false;

  this.Orders.forEach(element => {
    if(element.IsSelected){
      this.AnyChecked = true;
    }
  });
}

SelectAll(){
  this.Orders.forEach(r => {
    r.IsSelected = this.AllSelected;
  });

  this.CheckIfAnyChecked();
}

InitializePartnersOnClick(searchTerm:string, CountryID:number, resetPaging:boolean){
  var request = {
    SearchTerm:searchTerm,
    CountryID:CountryID,
    PageIndex:1,
    PageSize:10,
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Company:this.parent.Company
  };

  if((this.searchTerm.length >= 3) && (this.Partners == null || this.Partners.length == 0)){
    this.parent.loading = true;

    this.service.GetPartnersFiltered(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.Partners = response["Partners"];
       this.resultsLength = response["Count"];
      }
   
      this.parent.loading = false;
    });
  }
  else{
    this.Partners = [];
    this.resultsLength = 0;
  }
}

GetPartnersFiltered(searchTerm:string, CountryID:number, resetPaging:boolean){
  var request = {
    SearchTerm:searchTerm,
    CountryID:CountryID,
    PageIndex:1,
    PageSize:50,
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Company:this.parent.Company
  };

  if(this.searchTerm.length >= 3){
    this.parent.loading = true;

    this.service.GetPartnersFiltered(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.Partners = response["Partners"];
       this.resultsLength = response["Count"];

       if(this.Partners.length == 1){
        this.partner = this.Partners[0]; this.resultsLength = 0; this.searchTerm = this.Partners[0].Name; this.Filter.Partner = this.Partners[0]; this.AddActiveFilter(this.Partners[0].Name, 'Partner');
        this.GetOrdersFiltered(1);
       }
      }
   
      this.parent.loading = false;
    });
  }
}

InitializeUserManagersOnClick(searchTerm:string){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    SearchTerm:searchTerm,
  };

  if((searchTerm.length >= 3) && (this.UserManagers == null || this.UserManagers.length == 0)){
    this.parent.loading = true;

    this.service.GetUsersFiltered(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.UserManagers = response["Users"];
        this.UserManagersLength = this.UserManagers.length;
      }
   
      this.parent.loading = false;
    });
  }
  else{
    this.UserManagers = [];
    this.UserManagersLength = 0;
  }
}

GetUserManagersFiltered(s:string){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    SearchTerm:s,
  };

  this.parent.loading = true;

  this.service.GetUsersFiltered(request).subscribe(response => {
 
    if(response["Status"] != 1){
    
    }
    else if(response["Status"] == 1){
      this.UserManagers = response["Users"];
      this.UserManagersLength = this.UserManagers.length;
    }
 
    this.parent.loading = false;
  });

}

InitializeUserUploadersOnClick(searchTerm:string){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    SearchTerm:searchTerm,
  };

  if((searchTerm.length >= 3) && (this.UserUploaders == null || this.UserUploaders.length == 0)){
    this.parent.loading = true;

    this.service.GetUsersFiltered(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.UserUploaders = response["Users"];
        this.UserUploadersLength = this.UserUploaders.length;
      }
   
      this.parent.loading = false;
    });
  }
  else{
    this.UserUploaders = [];
    this.UserUploadersLength = 0;
  }
}

GetUserUploadersFiltered(s:string){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    SearchTerm:s,
  };

  this.parent.loading = true;

  this.service.GetUsersFiltered(request).subscribe(response => {
 
    if(response["Status"] != 1){
    
    }
    else if(response["Status"] == 1){
      this.UserUploaders = response["Users"];
      this.UserUploadersLength = this.UserUploaders.length;
    }
 
    this.parent.loading = false;
  });

}

OpenOrderCancelation(o:any){
  this.CurrentOrder = JSON.parse(JSON.stringify(o));
  this.ShowOrderCancelation = true;
}

CancelOrder(o:any){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    DBID:o.DBID,
  };

  this.parent.loading = true;

  this.B2BService.CancelOffer(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Orders.forEach(order => {
        if(order.DBID == o.DBID){
          order.ProcessingStatus = response["ProcessingStatus"];
          order.OfferStatus = response["OfferStatus"];
        }
      });
    }
 
    this.parent.loading = false;
  });
}

OpenCopyOrder(o:any){
  this.CurrentOrder = JSON.parse(JSON.stringify(o));
  this.ShowOrderCopy = true;
}

CopyOrder(o:any){
  this.GetOffer(o.ID);
}

GetOffer(OfferID:string){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    RequestOfferID:OfferID,
    GetCartItems:true,
    WithLogs:true,
  };

  this.parent.loading = true;

  this.B2BService.GetB2BOffer(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.CurrentOrder = response["Offer"];
      this.ShowEditContainer = true;

      // Scroll to top of page after a short delay
      setTimeout(() => {
        // Scroll to top of page - target the scrollable container
        const scrollContainer = document.querySelector('.loginBodyContainer');
        if (scrollContainer) {
          scrollContainer.scrollTo({ top: 0, behavior: 'smooth' });
        }
        // Fallback to window scroll
        window.scrollTo({ top: 0, behavior: 'smooth' });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      }, 100);
    }

    this.parent.loading = false;
  });
}

ResetMainSearch() {
  this.Filter.SearchTerm = '';
  this.GetOrdersFiltered(1);
}

PrintOrder(o:any){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    ID:o.ID,
  };

  this.parent.loading = true;

  this.B2BService.ExportOffer(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      var Document = response["Document"];
      this.printPage(Document.Name , Document.PDFStream, Document.ID);
    }

    this.parent.loading = false;
  });
}

download(filename, text) {
  var element = document.createElement('a');
  element.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(text));
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

ExportOrder(o:any){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    ID:o.ID,
  };

  this.parent.loading = true;

  this.B2BService.ExportOffer(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      var Document = response["Document"];
      this.download(Document.Name, Document.PDFStream);
    }

    this.parent.loading = false;
  });
}


printPage(name:string, html:string, ID:string) {
  var winparams = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
  'resizable,screenX=50,screenY=50,width=850,height=1050';

var htmlPop = '<embed width=100% height=100%'
  + ' type="application/pdf"'
  + ' src="data:application/pdf;base64,'
  + escape(html)
  + '"></embed>';

var newWindow = window.open("", 'PDF_' + name +"_"+ ID);
newWindow.document.write(htmlPop);
};

ShowAllProductsDetails:boolean = false;

ShowAllProductsDetailsFunction(e:boolean){
  this.ShowAllProductsDetails = e;
  this.CurrentOrder.Cart.Items.forEach(element => {
    element.Product.ShowDetails = e;
  });
}

AddNewOffer(){

   this.CurrentOrder.UserUploader = this.parent.User;
   this.CurrentOrder.AgentManager = this.parent.B2BAgent;
   this.CurrentOrder.Company = this.parent.Company;

   var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
     OfferRequest:this.CurrentOrder
   };

   this.parent.loading = true;

   this.B2BService.AddNewOfferRequest(request).subscribe(response => {
 
     if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
     }
 
     this.parent.loading = false;
    });
  
 }

 AcceptNewlyQuotedPricesOfferLoading:boolean;

 AcceptNewlyQuotedPricesOffer(){

  this.CurrentOrder.UserUploader = this.parent.User;
  this.CurrentOrder.AgentManager = this.parent.B2BAgent;
  this.CurrentOrder.Company = this.parent.Company;

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    OfferRequest:this.CurrentOrder
  };

  this.AcceptNewlyQuotedPricesOfferLoading = true;

  this.B2BService.AcceptNewlyQuotedPricesOffer(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      this.GetOrdersFiltered();
    }

    this.ShowEditContainer = false;
    this.AcceptNewlyQuotedPricesOfferLoading = false;
   });

}

goToAcceptOffer() {
  if (this.CurrentOrder?.ID) {
    // Use window.location for URL with query params
    window.location.href = '/B2B/accept/offer?id=' + this.CurrentOrder.ID;
  }
}

}
